import { useApi } from '../api/ApiContext'
import { notifyError } from '../lib/notify'

/** "Export all data": asks the API for the export and downloads it; a failure shows as a notification. */
export function useExportData(): () => Promise<void> {
  const api = useApi()
  return async () => {
    try {
      window.location.assign((await api.exportData()).url)
    } catch (error) {
      notifyError(new Error(`Export failed: ${(error as Error).message}`))
    }
  }
}
